import type { ItemOperation } from "../schemas/items";

/**
 * The key that names an item's operation row across writes: `<operationId>`
 * for the first row of an operation, `<operationId>~<n>` for its n-th repeat.
 */
export function operationRowKey(
  operation: Pick<ItemOperation, "operationId">,
  index: number,
  operations: readonly Pick<ItemOperation, "operationId">[],
): string {
  const ordinal =
    operations
      .slice(0, index)
      .filter((prior) => prior.operationId === operation.operationId).length +
    1;
  return ordinal === 1
    ? operation.operationId
    : `${operation.operationId}~${ordinal}`;
}
